import { deleteRequestWithBody, getRequest } from '../../../core/utils/api';
import AppUser from '../../check-in-employees/models/app-user';
import { type KeycloakContext } from '../keycloak/KeycloakProvider';
import OfficeManagerUser from '../models/officeManagerUser';
import type User from '../models/user';

export const getAllOfficeManagersForUser = async (keycloak: KeycloakContext): Promise<OfficeManagerUser[] | undefined> => {
  const apiResponse = await getRequest<OfficeManagerUser[]>('office-user/officemanagers', keycloak);
  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};

export const getUserForOfficeManagerByEmail = async (keycloak: KeycloakContext, email: string): Promise<AppUser | undefined> => {
  const apiResponse = await getRequest<AppUser>(`office-user/by-email?email=${email}`, keycloak);
  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};

export const deleteOfficeManagerById = async (id: string, email: string, keycloak: KeycloakContext): Promise<boolean> => {
  const apiResponse = await deleteRequestWithBody('office-user/officemanager', keycloak, { Email: email, OfficeUserId: id });
  return !apiResponse.error;
};

export const getAllOfficeUsers = async (officeId: string, keycloak: KeycloakContext): Promise<User[] | undefined> => {
  const apiResponse = await getRequest<User[]>(`office-user/by-query/${officeId}?pageIndex=0&pageSize=5000`, keycloak);

  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};
